import React, { useState, useEffect, useContext } from 'react';
import '../../App.css';
import BookingAddOn from '../BookingAddOn';
import BookingAddOnDeals from '../BookingAddOnDeals';
import { BookingDetails } from '../BookingDetails';
import { BookingHeader } from '../BookingHeader';
import { useSearchParams } from 'react-router-dom';
import { LoadingScreenModal } from '../LoadingScreenModal';
import {
	convertEBticketToCWLticket,
	tokenIsValid,
	getToken,
} from '../Function';
// CryptoJS import removed: browser-side reward hashing is no longer used
// (loyalty redeem is now handled server-side by the Express API).

function PaymentAck() {
	sessionStorage.removeItem('selected_addon_data');
	sessionStorage.removeItem('busFare');
	sessionStorage.removeItem('departData');
	sessionStorage.removeItem('returnData');
	sessionStorage.removeItem('loyalty');
	sessionStorage.removeItem('addOn');
	sessionStorage.removeItem('selectedDepartSeat');
	sessionStorage.removeItem('selectedReturnSeat');
	sessionStorage.removeItem('addOnSession');
	sessionStorage.removeItem('addon_data');
	sessionStorage.removeItem('Destination_data');
	sessionStorage.removeItem('Origin_data');
	sessionStorage.removeItem('depart_TripKey');
	sessionStorage.removeItem('return_TripKey');
	sessionStorage.removeItem('rescheduleAmount');
	sessionStorage.removeItem('history_guid');
	sessionStorage.removeItem('addOn');
	sessionStorage.removeItem('oldcartguid');
	//remove checkout expiry timestamp
	sessionStorage.removeItem('checkout_expiry_ts');

	const SERVER_URL = process.env.REACT_APP_SERVER_URL;
	// MANJA reward env vars removed: reward redeem (NEW/CLAIM/DELETE) is now
	// called server-side by the Express API, not from the browser.
	// var cust_email = sessionStorageGetItem("primary_email");
	// if (cust_email != null) {
	//   cust_email = JSON.parse(cust_email);
	// }
	const [searchParams, setSearchParams] = useSearchParams();
	const status_id = searchParams.get('status_id');
	const order_id = searchParams.get('order_id');
	const transaction_id = searchParams.get('transaction_id');
	const msg = searchParams.get('msg');
	const hash = searchParams.get('hash');
	const paymentType = searchParams.get('payment_type');
	const [bookingHistoryData, setBookingHistoryData] = useState(null);
	const [loading, setLoading] = useState(true);
	// const [userBookingHistoryData, setUserBookingHistoryData] = useState(null);
	const [responseStatus, setResponseStatus] = useState(null);
	const token = getToken();

	var payment_status = 'Failed';
	if (status_id === '1') {
		payment_status = 'Confirmed';
	}

	// console.log(responseStatus)
	// console.log(token)
	useEffect(() => {
		tokenIsValid();
		try {
			// Simple POST request with a JSON body using fetch
			const requestOptions = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: token,
				},
				body: JSON.stringify({
					StatusID: `${status_id}`, //min payment amount
					OrderID: `${order_id}`,
					TransactionID: `${transaction_id}`,
					Msg: `${msg}`,
					Hash: `${hash}`,
					PaymentType: `${paymentType}`,
				}),
			};

			fetch(`${SERVER_URL}/order/update/${order_id}`, requestOptions)
				.then((response) => {
					console.log(response);
					if (response.status === 200) {
						// console.log("SUCCESSS")
						setResponseStatus(response.status);
						return response.json();
					} else if (response.status === 206) {
						// console.log("Pending confirmation")
						setResponseStatus(response.status);
						return response.json();
						// throw new Error(response.status)
					} else {
						// console.log("Bad Request")
						setResponseStatus(response.status);
						setLoading(false);
						return response.json();
						// throw new Error(response.status);
					}
				})
				.then((data) => {
					// console.log('order update response');
					// console.dir(data);
					// [DISABLED 2026-06-23] Loyalty redeem is now handled server-side by the
					// Express API: OrderController.InsertOrderRequest sends NEW (hold) at order
					// creation, and UpdateOrderStatus sends CLAIM on payment success / DELETE on
					// failure (see RewardRepository.UpdateRedeemStatusAsync). Firing the reward
					// API from the browser here would double-fire and could release a hold the
					// server just claimed, so this call has been removed.
					setBookingHistoryData(data);

					// console.log('bookingHistoryData=');
					// console.dir(bookingHistoryData);
				});
		} catch (err) {
			// console.log(`[Err]${err}`);
			setLoading(false);
		}
	}, [token]);

	// useEffect(() => {
	//   const getBookingHistoryData = async () => {
	//       try {
	//           const response = await fetch(`${SERVER_URL}/order/history/${bookingHistoryData.orderstatus.cust_email}`,
	//           {
	//             headers: {
	//                 'Authorization': token
	//             }
	//           });
	//           if (!response.ok) {
	//               throw new Error(
	//                   `This is an HTTP error: The status is ${response.status}`
	//               );
	//           }
	//           let actualData = await response.json();
	//           setUserBookingHistoryData(actualData);
	//           // sessionStorageSetItem("subplace_data",JSON.stringify(actualData));
	//           // console.log(actualData)
	//       } catch (err) {
	//           setUserBookingHistoryData(null);
	//           setLoading(false)
	//       }
	//   }
	//   tokenIsValid()
	//   getBookingHistoryData()
	// },[bookingHistoryData,token]);

	console.log(bookingHistoryData);
	// console.log(userBookingHistoryData)
	if (responseStatus === 200 && bookingHistoryData !== null) {
		if (loading === true) {
			setLoading(false);
		}
		return (
			<>
				{loading && (
					<div className='center'>
						<LoadingScreenModal />
					</div>
				)}
				<BookingHeader
					printTicket='Print Ticket'
					ticket_id={
						bookingHistoryData.ordersummary.ticketid ||
						(bookingHistoryData.orderinfo
							? bookingHistoryData.orderinfo.ticket_id
							: null)
					}
					// ticket_id={bookingHistoryData.ordersummary.ticketid}

					ticket_id_hash={
						bookingHistoryData.ordersummary.ticketidhash ||
						(bookingHistoryData.orderinfo
							? bookingHistoryData.orderinfo.ticket_id_hash
							: null)
					}
					// ticket_id_hash={bookingHistoryData.ordersummary.ticketidhash}

					booking_status={payment_status}
					trip_id={bookingHistoryData.ordersummary.ordernumber}
					amount={bookingHistoryData.ordersummary.totalamount}
					email={bookingHistoryData.orderstatus.cust_email}
				></BookingHeader>
				<BookingDetails
					bookingDetail={bookingHistoryData}
					// depart_info={depart_info}
					// return_info={return_info}
					// data_depart_place_name={bookingHistoryData.orders.depart_place_name}
					// data_return_place_name={bookingHistoryData.orders.return_place_name}
					// data_passenger={bookingHistoryData.orders.no_of_pax}
					view='true'
				></BookingDetails>
			</>
		);
	} else if (responseStatus === 206 && bookingHistoryData !== null) {
		if (loading === true) {
			setLoading(false);
		}
		return (
			// <div className='center'>
			// <LoadingScreenModal />
			// </div>
			<>
				<BookingHeader
					booking_status={'Pending Confirmation'}
					email={bookingHistoryData.orderstatus.cust_email}
				></BookingHeader>
				<BookingDetails
					bookingDetail={bookingHistoryData}
					view='true'
				></BookingDetails>
			</>
		);
	} else if (responseStatus === null) {
		return <LoadingScreenModal />;
	} else {
		return (
			<>
				{loading && (
					<div className='center'>
						<LoadingScreenModal />
					</div>
				)}
				<BookingHeader booking_status={'Failed'}></BookingHeader>
				<BookingDetails
					bookingDetail={bookingHistoryData}
					view='true'
				></BookingDetails>
			</>
		);
	}
}

export default PaymentAck;
